function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,30.980392%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 4.160156 26.953125 L 1.757812 0 L 28.183594 0 L 25.78125 26.953125 L 14.941406 30 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,39.607843%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 15 27.65625 L 23.730469 25.253906 L 25.78125 2.167969 L 15 2.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 15 12.1875 L 10.605469 12.1875 L 10.3125 8.789062 L 15 8.789062 L 15 5.507812 L 6.679688 5.507812 L 7.558594 15.527344 L 15 15.527344 Z M 14.941406 20.800781 L 11.25 19.804688 L 11.015625 17.167969 L 7.734375 17.167969 L 8.144531 22.382812 L 14.941406 24.257812 Z M 14.941406 20.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.941406 12.1875 L 14.941406 15.527344 L 19.042969 15.527344 L 18.632812 19.804688 L 14.941406 20.800781 L 14.941406 24.257812 L 21.738281 22.382812 L 22.675781 12.1875 Z M 14.941406 5.507812 L 14.941406 8.789062 L 22.96875 8.789062 L 23.261719 5.507812 Z M 14.941406 5.507812 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.93af5f686ea85d21b000475cc6c4d672.svg";
export { ForwardRef as ReactComponent };